export const SUBJECT = [
  { title: "HTML/CSS", value: "html/css", img: "html-logo.png" },
  { title: "JavaScript", value: "javaScript", img: "JavaScript-logo.png" },
  { title: "React", value: "react", img: "react-logo.png" },
  { title: "Node.js", value: "nodejs", img: "nodejs logo.png" },
  { title: "Typescript", value: "typescript", img: "typescript-logo.png" },
  { title: "바이브코딩", value: "vibecoding", img: "vibecoding.jpeg" },
];
